import { useEffect } from "@wordpress/element";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { Button, TextField } from "vino/core";
import { useCheckoutContext } from "vino/context";
import { ContactSchema, contactDefaultValues } from "../../models";
import ShippingAddress from "./ShippingAddress";
import {
	createCheckout,
	updateCheckout,
	setAddress,
} from "store/vino/checkoutSlice";

const CustomerInformation = () => {
	const dispatch = useDispatch();
	const user = useSelector((state) => state.auth.user);
	const checkout = useSelector(({ vino }) => vino.checkout);
	const { cartLineItems, cartId } = useCheckoutContext();
	const methods = useForm({
		mode: "onChange",
		defaultValues: contactDefaultValues,
		resolver: yupResolver(ContactSchema),
	});

	const { data, isUserLoaded } = user;
	const { handleSubmit, setValue } = methods;
	const { customer, isSubmitting } = checkout;

	useEffect(() => {
		if (customer) {
			if (customer.email) {
				setValue("email", customer.email);
			}
			setValue("address", customer.address);
		}
	}, [customer, setValue]);

	useEffect(() => {
		if (user.data && user.isUserLoaded) {
			setValue("email", user.data.email);
			setValue("address.firstName", user.data.firstName);
			setValue("address.lastName", user.data.lastName);
		} else {
			setValue("addNewAddress", true);
		}
	}, [user, setValue]);

	const handleAddressChange = (address) => {
		dispatch(setAddress(address));
	};

	const onSubmit = (model) => {
		if (checkout.checkoutId) {
			dispatch(
				updateCheckout({
					checkout,
					customer: { id: checkout.customer.id, ...model },
				})
			);
		} else {
			dispatch(
				createCheckout({
					cartId,
					cartLineItems,
					customer: model,
				})
			);
		}
	};

	return (
		<Paper className="flex flex-col justify-center flex-auto md:flex-row md:p-0 overflow-hidden">
			<FormProvider {...methods}>
				<form
					noValidate
					className="w-full flex flex-col px-16"
					onSubmit={handleSubmit(onSubmit)}
					autoComplete="off"
				>
					<div className="flex mt-20 mb-10 justify-between">
						<Typography className="text-16 font-medium">
							Contact information
						</Typography>

						{!isUserLoaded && <a href="/login">Login</a>}
					</div>
					<div className="mb-20 w-ful">
						{!isUserLoaded && (
							<TextField
								name="email"
								label="Email"
								required
								fullWidth
								autoFocus
							/>
						)}

						{isUserLoaded && <Typography>{data.email}</Typography>}
					</div>

					<div className="flex flex-col ">
						<ShippingAddress onChange={handleAddressChange} />
						<div className="flex justify-end w-full mb-20">
							<Button isSubmitting={isSubmitting} type="submit">
								Next: Shipping Options
							</Button>
						</div>
					</div>
				</form>
			</FormProvider>
		</Paper>
	);
};

export default CustomerInformation;
